module.exports = __webpack_public_path__ + "static/media/RseauxSociaux.4efd7a91.pdf";